import React from 'react'
import { motion } from 'framer-motion';

const Skills = () => {
  const skillGroups = [
    {
      title: "Languages & Core",
      skills: [
        { name: "C++", level: "95%" },
        { name: "Dart", level: "95%" },
        { name: "Go lang", level: "85%" },
        { name: "Mongodb & SQL", level: "90%" },
      ]
    },
    {
      title: "Frameworks & Tools",
      skills: [
        { name: "Flutter", level: "98%" },
        { name: "React", level: "80%" },
        { name: "Node.js", level: "80%" },
        { name: "Git & Github", level: "95%" },
      ]
    }
  ];

  return (
    <div className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-16">
      {skillGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="w-full lgl:w-1/2">
          <div className="py-6 font-titleFont flex flex-col gap-3 mb-8">
            <p className="text-sm text-cyan-400 tracking-[4px] uppercase">{group.title}</p>
            <h2 className="text-2xl md:text-3xl font-bold text-white">Development Skills</h2>
          </div>
          <div className="flex flex-col gap-6">
            {group.skills.map((skill, index) => (
              <div key={index} className="overflow-x-hidden">
                <div className="flex justify-between mb-2">
                  <p className="text-sm font-medium text-gray-300">{skill.name}</p>
                  <p className="text-sm text-cyan-400">{skill.level}</p>
                </div>
                <span className="w-full h-2 bg-white/5 rounded-full inline-flex overflow-hidden">
                  <motion.span
                    initial={{ x: "-100%", opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: index * 0.1 }}
                    className="h-full bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full"
                    style={{ width: skill.level }}
                  />
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Skills
